.br{flex-shrink:0;}